{
  "heading": "Your invitations",
  "subheading_one": "You've been invited to join an organization.",
  "subheading_other": "You've been invited to join {{count}} organizations.",
  "invited_by": "Invited by {{name}}",
  "type_family": "Family",
  "type_business": "Organization",
  "role_editor": "Editor",
  "expires": "Expires {{date}}",
  "accept": "Accept",
  "accepted": "You've joined {{organization}}",
  "accept_error": "Something went wrong accepting this invitation",
  "error": "We couldn't load your invitations.",
  "retry": "Try again",
  "close": "Close"
}
